<template>
  <a-config-provider :locale="zhCN">
      <router-view />
  </a-config-provider>
</template>

<script>
document.title = "后台管理系统";
import zhCN from 'ant-design-vue/es/locale/zh_CN';
export default {
  setup() {
      return {
          zhCN,
      };
  },
}
</script>
<style>
body, #app{
    height: 100%;
}
</style>